import _ from "lodash";

function useAutosave({ onSave = _.noop, wait = 600 }: { onSave?: () => void; wait?: number }) {
  const save = _.debounce(onSave, wait);

  return save;
}

export default useAutosave;
